
export const setAssessmentTemplates = (value) => {
  return {
    type: "SET_ASSESSMENT_TEMPLATES",
    payload: { data: value },
  };
};
export const setTreatmentTemplates = (value) => {
  return {
    type: "SET_TREATMENT_TEMPLATES",
    payload: { data: value },
  };
};

export const setActiveMedicalRecordTemplate = (value) => {
  return {
    type: "SET_ACTIVE_MEDICAL_RECORD_TEMPLATE",
    payload: { data: value },
  };
};
export const setShowMedicalRecoedTemplate = (value) => {
  return {
    type: "SET_SHOW_FOLLOW_UP_MODAL",
    payload: { data: value },
  };
};
export const setMedicalVisitId = (value) => {
  return {
    type: "SET_VISIT_MEDICAL_ID",
    payload: { data: value },
  };
};

